import { render, staticRenderFns } from "./TheChatMessagesDisplay.vue?vue&type=template&id=20c953f8"
import script from "./TheChatMessagesDisplay.vue?vue&type=script&lang=js"
export * from "./TheChatMessagesDisplay.vue?vue&type=script&lang=js"
import style0 from "./TheChatMessagesDisplay.vue?vue&type=style&index=0&id=20c953f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports